import { graphql, type ResultOf } from '@tucan/graphql'

export const COMPANY_FRAGMENT = graphql(`
  fragment Company on Company @_unmask {
    id
    name
    referralCode: coupon
    isIpAllowed
    slug
    lang
    logo: logoUrl(size: 250)
    isAdmin
    isMember
    isWorker
    features
  }
`)

export type CompanyFragment = ResultOf<typeof COMPANY_FRAGMENT>
